module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"logout":"Выход","help":"Справка","support":"Техническая поддержка","write_to_support":"Написать в техподдержку","search_no_results":"По Вашему запросу ничего не найдено"},"en":{"logout":"Logout","help":"Help","support":"Technical support","write_to_support":"Contact technical support","search_no_results":"No results for your search were found"}}')
  delete Component.options._Ctor
}
